import * as React from 'react'
import { useIntl, Link } from 'gatsby-plugin-react-intl'
import { CountryBase } from 'templates/fragments/country'
import { RegionStub } from 'templates/fragments/region'
import { OutboundLink } from 'gatsby-plugin-google-gtag'
import getLocationPath from 'services/getLocationPath'


export const DesktopFooter = ({ bestCountries, bestRegions }: { bestCountries: CountryBase[], bestRegions: RegionStub[] }) => {
    const intl = useIntl()

    return (<footer className="footer">
        <div className="row">
            <div className="col col--sm--4">
                <div className="h5 mb--50 footer--description">
                    {intl.formatMessage({ id: 'footer.aboutSunheron.title' })}
                </div>
                <ul className="footer__list">
                    <li className="footer__list__item"> <Link to="/about-us/">{intl.formatMessage({ id: 'footer.aboutSunheron.aboutUs' })} </Link> </li>
                    <li className="footer__list__item"> <Link to="/privacy-policy/"> {intl.formatMessage({ id: 'footer.aboutSunheron.privacyPolicy' })} </Link> </li>
                    <li className="footer__list__item"> <Link to="/cookie-policy/"> {intl.formatMessage({ id: 'footer.aboutSunheron.cookiePolicy' })} </Link> </li>
                    <li className="footer__list__item"> <Link to="/faq/">FAQ</Link> </li>
                    <li className="footer__list__item"> <Link to="/contact/"> {intl.formatMessage({ id: 'footer.aboutSunheron.contact' })} </Link> </li>
                </ul>
            </div>
            {/* <div className="col col--sm--2">
                    <h3 className="h5 mb--50 footer--description">
                        {intl.formatMessage({id: 'footer.usefullInfo'})}
                    </h3>
                    <ul className="footer__list">
                        <li className="footer__list__item"> <Link to="/">{intl.formatMessage({id: 'footer.usefullInfo.destinationsGuide'})} </Link> </li>
                        <li className="footer__list__item"> <Link to="/">{intl.formatMessage({id: 'footer.usefullInfo.airportsGuide'})} </Link> </li>
                        <li className="footer__list__item"> <Link to="/">{intl.formatMessage({id: 'footer.usefullInfo.airlinesGuide'})}</Link> </li>
                    </ul>
                </div> */}
            <div className="col col--sm--4">
                <div className="h5 mb--50 footer--description">
                    {intl.formatMessage({ id: 'footer.topCountries' })}
                </div>
                <div className="row row--ng">
                    <div className="col col--ng col--sm--6">
                        <ul className="footer__list footer__list--in_row">
                            {bestCountries.slice(0, 5).map(country => (
                                <li key={country.slug} className="footer__list__item"> <Link to={getLocationPath({ location: country, isCountryInstance: true, monthIndex: 12 })}>{country.name} </Link> </li>
                            ))}
                        </ul>
                    </div>
                    <div className="col col--ng col--sm--6">
                        <ul className="footer__list footer__list--in_row">
                            {bestCountries.slice(5, 10).map(country => (
                                <li key={country.slug} className="footer__list__item"> <Link to={getLocationPath({ location: country, isCountryInstance: true, monthIndex: 12 })}>{country.name} </Link> </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col col--sm--4">
                <div className="h5 mb--50 footer--description">
                    {intl.formatMessage({ id: 'footer.topDestinations' })}
                </div>
                <div className="row row--ng">
                    <div className="col col--ng col--sm--6">
                        <ul className="footer__list footer__list--in_row">
                            {bestRegions.slice(0, 5).map(region => {
                                return (<li key={region.slug} className="footer__list__item"> <Link to={getLocationPath({ location: region, isCountryInstance: false, monthIndex: 12 })}>{region.name} </Link> </li>
                                )
                            })}
                        </ul>
                    </div>
                    <div className="col col--ng col--sm--6">
                        <ul className="footer__list footer__list--in_row">
                            {bestRegions.slice(5, 10).map(region => (
                                <li key={region.slug} className="footer__list__item"> <Link to={getLocationPath({ location: region, isCountryInstance: false, monthIndex: 12 })}>{region.name} </Link> </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <hr className="hr--m2" />
        <div className="row">
            <OutboundLink href="https://www.facebook.com/sunheronweather" target="_blank">
                <p className="col col--sm--1 footer--copyright">Facebook</p>
            </OutboundLink>
            <OutboundLink href="https://www.instagram.com/sunheron/" target="_blank">
                <p className="col col--sm--1 footer--copyright">
                    Instagram
                </p>
            </OutboundLink>
            <p className="col col--sm--10 footer--copyright text--right">
                {intl.formatMessage({ id: 'footer.reservedRights' })}
            </p>
        </div>
    </footer>
    )
}
